import "./style.css";
import gsap from "gsap";
import inView from "in-view";

export default class Hero {
  static selector = ".s-layout__carousel";

  constructor(block) {
    this.block = block;
  }

  onExitView() {
    this.block.classList.remove("in-view");

    const $swiper = this.block.querySelector(".swiper-wrapper");
    gsap.to($swiper, {
      duration: 1.5,
      delay: 0.45,
      ease: "elastic.out",
      left: window.innerWidth < 960 ? 60 : 120,
    });
  }

  onEnterView() {
    this.block.classList.add("in-view");

    const $swiper = this.block.querySelector(".swiper-wrapper");
    gsap.to($swiper, {
      duration: 1.5,
      delay: 0.45,
      ease: "elastic.out",
      left: 0,
    });
  }

  onReady() {
    inView.threshold(0.5);
    inView(".s-layout__carousel")
      .on("enter", this.onEnterView.bind(this))
      .on("exit", this.onExitView.bind(this));
  }
}
